// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"PaymentStatusChangeConfirmationModal_buttonsContainer__-wKHx"};